var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "59px",
    viewBox: "0 0 57 59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-2019",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "QPP-Prototype---Mobile---Confirmation---admin---alt",
    transform: "translate(-291.000000, -95.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "complete-checkmark-outline",
    transform: "translate(291.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6239151,19 L23.7753134,36.6364796 L17.4030858,30.0140306 L15,32.5114796 L22.56027,40.3686224 C22.8977821,40.7193878 23.3567985,41 23.7618129,41 C24.1668274,41 24.6123433,40.7193878 24.9498554,40.3826531 L43,21.5255102 L40.6239151,19 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5,0 C12.7564904,0 0,13.2040865 0,29.5 C0,45.7959135 12.7564904,59 28.5,59 C44.2435096,59 57,45.7959135 57,29.5 C57,13.2040865 44.2435096,0 28.5,0 Z M28.5,56 C13.8951232,56 2,44.1187729 2,29.5 C2,14.8951232 13.8812271,3 28.5,3 C43.1048768,3 55,14.8812271 55,29.5 C55,44.1048768 43.1048768,56 28.5,56 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.c8a184e35934e8a8145b8bea9d7240c6.svg";
export { ForwardRef as ReactComponent };